<template lang="pug">
  div.map-container.navigation-control
    div.toolbar.toolbar--big.toolbar--bordered
      div.line
        h1.title Карта
        form(@submit.stop.prevent="").search
          e-suggestion(
          v-if="currentCar && currentCar.id"
          placeholder="Искать вдоль маршрута"
          @selectItem="selectWaypoint"
          name="route"
          :model="suggestionMapSearch"
          :useInnerSearch="true"
          :options="waypointListData"
          )
          e-suggestion(
          v-else
          placeholder="Введите № автомобиля/маршрут"
          @selectItem="selectCar"
          name="auto"
          :model="suggestionMapSearch"
          :useInnerSearch="true"
          :options="items.data"
          )

    div.new-map
      div(ref="map" v-once)#map.bigmap
      template(v-if="currentCar && currentCar.id")
        transition(name="fade")
          div.legend.cuscroll.open.currentCar
            e-perfect-scrollbar
              div.head
                div.subtitle {{currentCar.name || 'n/a'}}
                span(@click="boundCar").legend__close
              div(v-if="currentCar.status_id === STATUS_ACTIVE").type-group
                div(v-if="currentCar.himanizeStartAt || currentCar.himanizeEndAt").route-info
                  div(v-if="currentCar.himanizeStartAt").route-info-line
                    label Начало работы:
                    span {{currentCar.himanizeStartAt}}
                  div(v-if="currentCar.himanizeEndAt").route-info-line
                    label Окончание работы:
                    span {{currentCar.himanizeEndAt}}
              div(v-else).type-group
                div.route-info
                  div.route-info-line
                    label Машина не на линии
                    span

              div.type-group.route
                div.group.flex
                  template(
                  v-if="currentCar.status_id === STATUS_ACTIVE"
                  v-for="instruction, index in currentCarInstructions"
                  )
                    template(
                    v-if="currentCar.routeData.waypointIndices.indexOf(instruction.index) > -1"
                    )
                      div.type
                        div(
                        v-bind:class="{ 'passed': instruction.waypointStatus == 0, 'active': instruction.waypointStatus == 1, 'coming': instruction.waypointStatus > 1 }"
                        ).marker
                          span.station {{instruction.road}}
                          span.time {{instruction.time}}

      template(v-else)
        transition(name="fade")
          div.legend.cuscroll.open.cat-list
            e-perfect-scrollbar
              div.head
                h2.title Слои
                div.legend-info &nbsp;
              div(v-for="item, name in layersConf" :class="'type-group ' + item.menuClass")
                div.type
                  label.checked
                    input.checkbox(type="checkbox" @change="onLayersChange(item, name)" v-model="layers" :value="name")
                    span
                    span.marker {{item.label}}
                  label.new-check
                    input.new-checkbox(type="checkbox")
                    span
                template(v-if="item.groups" v-for="groupItem, groupItemName in item.groups")
                  div(v-if="groupItem && !groupItem.hideFromMenu").group.layer
                    div(:class="'type ' + groupItem.menuClass")
                      label.checked
                        input.checkbox(type="checkbox" @change="onLayersChange(groupItem, groupItemName, name)" v-model="layers" :value="groupItemName")
                        span
                        span.marker {{groupItem.label}}

              div.head
                h2.title Машины
                div.legend-info {{activeItemsWithCars}} из {{itemsWithCars.length}} машин
              div.type-group
                div.group.flex
                  template(v-if="itemsWithCars.length")
                    div(
                    v-for="item in itemsWithCars"
                    @click.stop.prevent="onCarClick(item)"
                    ).type
                      // .planned .inactive .active
                      div(:class="getClassByStatusId(item.status_id)").marker
                        span {{item.name}}
                        div.progress
                          div.progress-loaded(:style="`width: ${item.progress}%`")

              div.type-group
                div.group.info
                  div.type
                    span.marker.active На линии
                  div.type
                    span.marker.inactive На ремонте
                  div.type
                    span.marker.planned Недоступен

              div.head
                h2.title Маршруты
                div.legend-info Всего {{items && items.data ? items.data.length : 0}}
              div.type-group
                div.group.flex
                  template(v-if="items && items.data && items.data.length")
                    div(
                    v-for="item in items.data"
                    @click.stop.prevent="onCarClick(item)"
                    ).type
                      // .planned .inactive .active
                      div(:class="getClassByHasCar(item)").marker
                        span {{item.name}}

              div.type-group
                div.group.info
                  div.type
                    span.marker.active Прикреплена машина
                  div.type
                    span.marker.inactive Нет прикрепленной машины

</template>

<script>
  import 'leaflet'
  import {MAP, TILE_LAYER} from '../../config/map.js'
  import {POLYGON} from "../../config/polygon"
  // import mapMixin from '../../mixins/map-mixin.js'
  import layersMixin from '../../mixins/layers-mixin.js'
  import CarDrawer from './utils/CarDrawer'
  import {map as mapEndpoints, transport, mongoApi, msn} from '../../api/api-endpoints.js'
  import {NavigationControlRoute} from "../../config/mongo"
  import {OBJECT} from "../../utils/map/types";
  import {STATUS_ACTIVE, STATUS_PLANED} from "../../config/config"
  import url from '../../utils/url'

  const STATUS_LEAVED = 0
  const STATUS_AT_THAT_POINT = 1
  const STATUS_FUTURE = 2

  export default {
    name: 'appeals-map',
    data () {

      this.mapLayers = null
      this.map = null
      this.carsMoveInterval = null

      return {
        suggestionMapSearch: {
          route: '',
          auto: ''
        },
        legendMode: 'all',
        currentCar: {},
        currentCarPosition: {}
      }
    },
    mixins: [layersMixin],
    computed: {
      waypointListData () {
        let list = []
        if (this.currentCarInstructions) {
          this.currentCarInstructions.forEach((instruction, i) => {
            if (instruction.road && this.currentCar.routeData.waypointIndices.indexOf(instruction.index) > -1) {
              list.push({
                id: i,
                name: instruction.road,
                coords: this.currentCar.routeData.coordinates[instruction.index]
              })
            }
          })
        }
        return list
      },
      STATUS_ACTIVE () {
        return STATUS_ACTIVE
      },
      currentCarInstructions () {
        if (this.currentCar.routeData.instructions) {
          let instructions = this.currentCar.routeData.instructions.slice()
          for (let i = 0; i < instructions.length; i++) {
            instructions[i].waypointStatus = STATUS_FUTURE
          }
          return instructions
        }
        return []
      },
      layersConf() {
        return this.getLayersConf()
      },
      mapBorders () {
        return this.$store.getters.readUrlEndpoint(
          mapEndpoints.heatMapRegOperators(this.$route.query.zoom || MAP.zoom)
        )
      },
      lives () {
        return this.$store.getters.readUrlEndpoint(this.getLiveEndpoint())
      },
      items () {
        return this.$store.getters.readUrlEndpoint(this.getItemsEndpoint())
      },
      itemsWithCars () {
        const withCars = []
        if (this.items && this.items.data) {
          this.items.data.forEach(item => {
            if (item.transport_vendor_id) {
              withCars.push(item)
            }
          })
        }
        return withCars
      },
      activeItemsWithCars () {
        let active = 0
        if (this.itemsWithCars.length > 0) {
          this.itemsWithCars.forEach(v => {
            if (v.status_id && v.status_id === STATUS_ACTIVE) {
              active++
            }
          })
        }
        return active
      }
    },
    created () {
      this.markerClickSubs = this.$emitter.listen('marker.click', e => this.onCarMarkerClick(e))
    },
    mounted () {
      this.carsMoveStart()
    },
    destroyed () {
      this.markerClickSubs.unsubscribe()
      this.carsMoveEnd()
    },
    methods: {
      getLayersConf () {
        return {
          msn: {
            iconType: 'places',
            menuClass: 'places',
            label: 'Места сбора и накопления',
            endpoint: mapEndpoints.msn,
            className: 'cluster-marker msn',
            groups: {
              container: {
                menuClass: 'places-cont',
                iconType: 'container',
                label: 'Контейнерные площадки',
                restApiOrder: 1
              },
              noContainer: {
                menuClass: 'places-noCont',
                iconType: 'noContainer',
                label: 'Бесконтейнерный сбор',
                restApiOrder: 2
              },
              separate: {
                menuClass: 'places-points',
                iconType: 'separate',
                label: 'Пункты сбора вторсырья',
                restApiOrder: 3
              }
            }
          }
        }
      },
      getParentsConf (layersArr, conf) {
        return layersMixin.methods.getParentsConf(layersArr, conf)
      },
      getLayerEndpoint (conf, type, route) {
        return layersMixin.methods.getLayerEndpoint(conf, type, route)
      },
      findCarByVendorId (vendorId) {
        let car = null
        if (vendorId && this.items && this.items.data) {
          this.items.data.forEach(v => {
            if (v.transport_vendor_id == vendorId) {
              car = v
            }
          })
        }
        return car
      },
      updateCurrentCarPosition () {
        let posUpdated = false
        if (this.currentCar && this.currentCar.transport_vendor_id && Array.isArray(this.lives)) {
          this.lives.forEach(v => {
            if (v.transport_vendor_id == this.currentCar.transport_vendor_id) {
              this.currentCar.lat = v.lat
              this.currentCar.lng = v.lon
              posUpdated = true
            }
          })
        }
        if (!posUpdated) {
          console.warn('posUpdated', posUpdated)
        }
      },
      drawMarkers () {
        if (this.lives && Array.isArray(this.lives)) {
          let markers = []
          this.lives.forEach(v => {
            if (v.lat && v.lon) {
              markers.push(Object.assign(v, {
                id: v.transport_vendor_id,
                rowId: v.id,
                name: v.name || v.transport_vendor_id,
                lng: v.lng || v.lon,
                layerConfig: {iconType: "transp"},
                subLayerConfig: {iconType: "transport"},
                type: OBJECT.CAR
              }))
            }
          })
          console.log(markers)
          if (this.carDrawer.routeExist()) {
            markers = markers.filter(m => {
              return m.transport_vendor_id == this.currentCar.transport_vendor_id
            })
          }
          this.carDrawer.drawAllCarMarkers(markers)
        }
      },
      refreshCarsData: async function (disableFitToBounds = true) {
        await this.$store.dispatch('updateUrlEndpoint', {
          endpoint: this.getLiveEndpoint()
        })
        this.drawMarkers()
        this.updateCurrentCarPosition()
      },
      startMoveInterval () {
        if (this.carsMoveInterval) {
          clearInterval(this.carsMoveInterval)
        }
        this.carsMoveInterval = setInterval(() => {
          this.refreshCarsData()
        }, 5000)
      },
      carsMoveStart: async function () {
        try {
          await this.refreshCarsData(false)
        } catch (e) {
          console.error(e)
        }
        this.startMoveInterval()
      },
      carsMoveEnd () {
        if (this.carsMoveInterval) {
          clearInterval(this.carsMoveInterval)
        }
      },
      selectWaypoint (item) {
        this.suggestionMapSearch.route = item.name
        this.map.setView(item.coords, 18)
      },
      selectCar (item) {
        this.suggestionMapSearch.auto = item.name
        this.expandCar(item)
      },
      getClassByHasCar (item) {
        let status = ' inactive'
        if (item.transport_vendor_id) {
          status = ' active'
        }
        return status
      },
      getClassByStatusId (statusId) {
        let status = ''
        if (statusId === STATUS_ACTIVE) {
          status = ' active'
        } else if (statusId === STATUS_PLANED) {
          status = ' planned'
        } else {
          status = ' inactive'
        }
        return status
      },
      boundCar () {
        this.currentCar = Object.create(null)
        this.carDrawer.removeCarRoute()
        if (this.prevPostiton && this.prevPostiton.zoom) {
          this.map.setView(
            this.prevPostiton.center,
            this.prevPostiton.zoom
          )
        }
        this.drawMarkers()
      },
      expandCar (car) {
        this.prevPostiton = {
          zoom: this.map.getZoom(),
          center: this.map.getCenter()
        }
        this.currentCar = Object.assign({}, car)
        this.updateCurrentCarPosition()
        this.carDrawer.cleanAllMarkers()
        this.carDrawer.drawCarRoute(this.currentCar, {disableColorize: true})
        this.drawMarkers()
      },
      onCarClick (car) {
        this.expandCar(car)
      },
      onCarMarkerClick (evt) {
        let {marker, routeExist = false} = evt
        if (!routeExist) {
          let vId = marker.options.model.transport_vendor_id
          let car = this.findCarByVendorId(vId)
          if (car) {
            this.expandCar(car)
          } else {
            let msg = `Не удалось найти привязку машины ${vId} к маршруту`
            this.$e.warningBox(msg, 15000)
            console.warn(msg)
          }
        }
        console.log(evt)
      },
      getMapConfig(key) {
        return MAP[key]
      },
      getMapPolygon () {
        return POLYGON
      },
      drawTiles () {
        L.tileLayer(TILE_LAYER, {}).addTo(this.map)
      },
      afterMapInit () {
        this.carDrawer = new CarDrawer(this.map, this)
        this.drawMarkers()
        this.initObjectsLayerDrawer()
      },
      /* required for use in map-poup.vue */
      popupIsOpened (markerInfo){
        return false
      },
      /* required for use in map-poup.vue */
      registerOpenPopup (markerInfo){},
      destroyMap () {
        console.log('destroyed')
        this.$emitter.emit('geo.destroyMap', {})
        // this.map.remove()
        this.map = null
      },
      getLiveEndpoint () {
        return transport.transportLive()
      },
      getItemsEndpoint () {
        return mongoApi.getCollectionItems(NavigationControlRoute, {
          query: {
            'per-page': -1
          }
        })
      }
    },
    asyncData ({store, route, fromRoute, methods}) {
      let promises = []

      promises.push(store.dispatch('updateUrlEndpoint', {
        endpoint: mapEndpoints.heatMapRegOperators(route.query.zoom || MAP.zoom),
        fromCache: true
      }))

      promises.push(store.dispatch('updateUrlEndpoint', {
        endpoint: methods.getLiveEndpoint()
      }))

      promises.push(store.dispatch('updateUrlEndpoint', {
        endpoint: methods.getItemsEndpoint()
      }))

      let usedRoute = url.getPrevOrCurrentRoute(route)
      if (usedRoute.query && usedRoute.query.layers && typeof usedRoute.query.layers === 'string'){
        let conf = methods.getParentsConf(usedRoute.query.layers.split(','), methods.getLayersConf())
        for (let key in conf) {
          if (methods.getLayerEndpoint(conf, key, usedRoute)){
            // console.log('asyncData ' + methods.getLayerEndpoint(conf, key, route))

            promises.push(store.dispatch('updateUrlEndpoint', {
              endpoint: methods.getLayerEndpoint(conf, key, usedRoute),
              cache: (60 * 15 * 1000),
              notReactive: true
            }))
          }
        }
      }

      if (promises.length === 0){
        return Promise.resolve(1)
      }

      return Promise.all(promises)
    }
  };
</script>

<style>
  .leaflet-routing-container{
    display: none;
  }
</style>
